export const footerSelectorID = "questionnaire-footer";
export const fieldContainerSelectorID = "field-container";
